import { take, call, fork } from 'redux-saga/effects';

import * as actions from 'actions'; // eslint-disable-line import/no-unresolved

function* watchForAnalyticsActions(analyticsTracker) {
    while(true) { // eslint-disable-line no-constant-condition
        const action = yield take([
            '@@router/LOCATION_CHANGE',
            actions.ANALYTICS_OUTLINK_SELECTED
        ]);

        yield call([analyticsTracker, analyticsTracker.processMembersAppAction], action);
    }
}

export default function* backgroundSaga(analyticsTracker) {
    yield [
        fork(watchForAnalyticsActions, analyticsTracker)
    ];
}


/** WEBPACK FOOTER **
 ** ./src/members/state/analytics/sagas.js
 **/